<template>
  <v-layout row wrap align-start align-content-start class="mb-2 xml-backlog-home">
    <!-- Title and Tabs -->
    <v-flex xs12>
      <v-toolbar tabs color="secondary" class="elevation-0">
        <v-icon class="mr-0 indigo--text text--lighten-5">code</v-icon>
        <v-toolbar-title class="white--text subheading ttu">
          {{ messages.title.XML_BACKLOG }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-flex>
    <!-- Main Content -->
    <v-layout>
      <v-flex xs12>
        <XMLBacklogSearchFilter />
        <XMLBacklogSearchResult />
      </v-flex>
    </v-layout>
    <v-flex xs12>
      <v-snackbar :bottom="true" :timeout="snackbar.timeout" color="error" v-model="snackbar.show">
        {{ snackbar.message }}
        <v-btn flat color="primary" @click.native="snackbar.show = false">Ok</v-btn>
      </v-snackbar>
    </v-flex>
    <XMLBacklogMetadataEdit />
  </v-layout>
</template>

<script>
import XMLBacklogSearchFilter from "@/XMLBacklog/XMLBacklogSearchFilter"
import XMLBacklogSearchResult from "@/XMLBacklog/XMLBacklogSearchResult"
import XMLBacklogMetadataEdit from "@/XMLBacklog/XMLBacklogMetadataEdit"
import AppService from "@/AppService"
import messages from "@/XMLBacklog/messages.json"

export default {
  name: "XMLBacklogHome",
  components: {
    XMLBacklogSearchFilter,
    XMLBacklogSearchResult,
    XMLBacklogMetadataEdit
  },
  data() {
    return {
      snackbar: {
        show: false,
        timeout: null,
        message: ""
      }
    }
  },
  methods: {},
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Events
     * */
    AppService.$on("event:xmlbServerError", () => {
      this.snackbar.show = true
      this.snackbar.message = this.messages.error.SERVER_ERROR
    })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/XMLBacklog/XMLBacklogHome.vue